import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { DigestionFilters } from "./components/DigestionFilters";
import {
  DigestionSearchRequestProvider,
  DigestionTable,
} from "./components/DigestionTable";

export function DigestionsPage() {
  return (
    <TablePage
      title="Search Digestions"
      navigation={<LqsNavigation />}
      RequestProvider={DigestionSearchRequestProvider}
      table={<DigestionTable />}
      filters={<DigestionFilters />}
    />
  );
}
